import Dashlet from "../../../controls/Dashlet";
import Placeholder from "../../../controls/EmptyPlaceholder";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { activeGameId } from "../../profile_management/selectors";
import GameThumbnail from "./GameThumbnail";
import PromiseBB from "bluebird";
import * as React from "react";
class RecentlyManaged extends ComponentEx {
    render() {
        const { t, discoveredGames, gameMode, lastActiveProfile, knownGames, profiles, } = this.props;
        const lastManaged = (id) => getSafe(profiles, [getSafe(lastActiveProfile, [id], undefined), "lastActivated"], 0);
        const games = knownGames
            .filter((game) => game.id !== gameMode &&
            lastManaged(game.id) !== 0 &&
            getSafe(discoveredGames, [game.id, "path"], undefined) !== undefined)
            .sort((lhs, rhs) => lastManaged(rhs.id) - lastManaged(lhs.id))
            .slice(0, 3);
        let content;
        if (games.length === 0) {
            // nothing recently managed
            content = (React.createElement(Placeholder, { icon: "game", text: t("You don't have any recently managed games"), fill: true }));
        }
        else {
            content = (React.createElement("div", { className: "list-recently-managed" }, games.map((game) => (React.createElement("div", { key: game.id, className: "recently-managed-analytics-click", onClick: this.analyticsTrack },
                React.createElement(GameThumbnail, { t: t, game: game, type: "managed", active: false, onRefreshGameInfo: this.refreshGameInfo }))))));
        }
        return (React.createElement(Dashlet, { title: t("Recently Managed"), className: "dashlet-recently-managed" }, content));
    }
    analyticsTrack = () => {
        this.context.api.events.emit("analytics-track-click-event", "Dashboard", "Recent game");
    };
    refreshGameInfo = (gameId) => {
        return new PromiseBB((resolve, reject) => {
            this.context.api.events.emit("refresh-game-info", gameId, (err) => {
                if (err !== null) {
                    reject(err);
                }
                else {
                    resolve();
                }
            });
        });
    };
}
function mapStateToProps(state) {
    return {
        gameMode: activeGameId(state),
        knownGames: state.session.gameMode.known,
        discoveredGames: state.settings.gameMode.discovered,
        lastActiveProfile: state.settings.profiles.lastActiveProfile,
        profiles: state.persistent.profiles,
    };
}
export default translate(["common"])(connect(mapStateToProps)(RecentlyManaged));
